/**
 * Shader behavior types that determine how they respond to dimension changes
 */
export enum ShaderBehavior {
  /** Texture-like shaders that should crop/expand rather than scale */
  TEXTURE = 'texture',
  /** Geometric/object shaders that should scale proportionally */
  GEOMETRIC = 'geometric',
}

/**
 * Shader categories for UI organization
 */
export enum ShaderCategory {
  EFFECTS = 'effects',
  OBJECTS = 'objects',
  PATTERNS = 'patterns',
  SIMULATIONS = 'simulations',
}

/**
 * Metadata interface for shader classification
 */
export interface ShaderMetadata {
  behavior: ShaderBehavior;
  category: ShaderCategory;
  description: string;
  tags: string[];
}
